import React, { useEffect } from 'react';
import './HomePage.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import logo from './images/logo.png'
import img1 from './images/ch.jpg'
import img2 from './images/hero2.jpg'
import img3 from './images/hero3.jpg'
import destination1 from './images/destination-1.jpg'
import destination2 from './images/destination-2.jpg'
import destination3 from './images/destination-3.jpg'
import hotel1 from './images/hotel-1.jpg'
import hotel2 from './images/hotel-2.jpg'
import hotel3 from './images/hotel-3.jpg'
import himanshu from './images/himanshu1.jpeg'


export default function HomePage() {
useEffect(()=>{
  let slideIndex = 0;
      showSlides();
    
      function showSlides() {
        let slides = document.getElementsByClassName("mySlides");
        for (let i = 0; i < slides.length; i++) {
          slides[i].style.display = "none";
        }
        slideIndex++;
        if (slideIndex > slides.length) {
          slideIndex = 1;
        }
        slides[slideIndex - 1].style.display = "block";
        setTimeout(showSlides, 4000); // Change image every 4 seconds
      }
},)

  return (
    <div>
   <nav class="navbar fixed-top  navbar-expand-lg navbar-light bg-light" >
      <a class="navbar-brand" href="#"><img width="80" height="70" class="d-inline-block align-top" src={logo} alt="logo" /></a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav">
          <li class="nav-item active">
            <a class="nav-link" href="#about">About <span class="sr-only">(current)</span></a>
          </li>
          <li class="nav-item"><a class="nav-link" href="#contact">Contact</a></li>
          <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" id="servicesDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Our Services
              </a>
              <div className="dropdown-menu" aria-labelledby="servicesDropdown">
                <a className="dropdown-item" href="/visa">Visa</a>
                <a className="dropdown-item" href="/domestic-tour">Domestic Tour</a>
                <a className="dropdown-item" href="/international-tour">International Tour</a>
                <a className="dropdown-item" href="/flights">Flight ✈️</a>
              </div>
            </li>
        </ul> 
      </div>
    </nav>
    <main>
      <section class="hero">
        <div class="hero">
          <div class="slideshow-container">
            <div class="mySlides fade">
              <img src={img1} alt="Slide 1" style={{'width':'100%' }}/>
            </div>
            <div class="mySlides fade">
              <img src={img2} alt="Slide 2" style={{'width':'100%' }}/>
            </div>
            <div class="mySlides fade">
              <img src={img3} alt="Slide 3" style={{'width':'100%' }}/>
            </div>
          </div>
          <div class="hero-content animated-hero" id="heroContent">
            <h1>Welcome to Admire Tourism</h1>
            <p>Discover amazing destinations and book your next trip with us.</p>
            {/* <a href="mailto:admiretourism@gmail.com" class="hero-button">Book Now</a> */}
          </div>
        </div>
             
      </section>

      <section id="destinations" class="destinations">
        <h2>Popular International Tours</h2>
        <div class="destination-grid">
          <div class="destination-item">
            <img src={destination1} alt="" />
            <h3>New York City</h3>
            <p>
              Visit the city that never sleeps and discover its iconic
              landmarks, world-class museums, and diverse neighborhoods.
            </p>
          </div>
          <div class="destination-item">
            <img src={destination2}  alt="" />
            <h3>Paris</h3>
            <p>
              Experience the romance and culture of the City of Lights, from the
              Eiffel Tower to the Louvre Museum.
            </p>
          </div>
          <div class="destination-item">
            <img src={destination3}  alt="" />
            <h3>Tokyo</h3>
            <p>
              Explore the vibrant city of Tokyo and immerse yourself in its
              unique blend of ancient traditions and modern technology.
            </p>
          </div>
        </div>
      </section>
      <section id="hotels" class="destinations">
        <h2>Popular  Domestic Tours</h2>
        <div class="destination-grid">
          <div class="destination-item">
            <img src={hotel1} alt="" />
            <h3>The Ritz Carlton</h3>
            <p>
              Experience luxury accommodations and impeccable service at The
              Ritz Carlton, located in the heart of the city.
            </p>
          </div>
          <div class="destination-item">
            <img src={hotel2} alt="" />
            <h3>The Four Seasons</h3>
            <p>
              Relax in style at The Four Seasons, featuring breathtaking views,
              an award-winning spa, and gourmet dining options.
            </p>
          </div>
          <div class="destination-item">
            <img src={hotel3} alt="" />
            <h3>The Waldorf Astoria</h3>
            <p>
              Indulge in luxury at The Waldorf Astoria, a historic landmark
              hotel renowned for its elegance and sophistication.
            </p>
          </div>
        </div>
      </section>
  

      <section id="about" class="about">
        <h3>About Me</h3>
        <p>
          I am dedicated to providing the best travel experiences to
          our customers. We specialize in creating custom itineraries that cater
          to each individual's interests and preferences.
        </p>
        <div class="team-members">
          <div class="team-member">
            <img src={himanshu} alt="" />
            <h4>Himanshu</h4>
            <p>Founder & CEO</p>
          </div>
          
        </div>
      </section>
      <section id="contact" class="contact">
        <h3>Contact Us</h3>
        <div class="contact-info">
          <p>
            If you have any questions or would like to book a trip, please  contact us using the information provided.
          </p>
          <ul>
            <li>
             <a href="https://maps.app.goo.gl/BM29s7vmi91Qd7Sm9"> <i class="fas fa-map-marker-alt"></i>Sarojini Colony, Model Town, Yamuna Nagar, Haryana 135001</a>
            </li>
            <li>
              <a href="mailto:admiretourism@gmail.com"
              >
              <i class="fas fa-envelope"></i>admiretourism@gmail.com</a
              >
            </li>
            <li>
              <a href="tel:7015293565"><i class="fas fa-phone-alt"></i
                >7015293565</a>
            </li>
          </ul>
        </div>
      </section>
      <footer>
        <div class="social-icons">
          <a href="https://www.facebook.com/people/Admire-Tourism/61552363347302/" target="_blank"
            ><i class="fab fa-facebook"></i
          ></a>
          <a href="https://www.instagram.com/admiretourism" target="_blank"
            ><i class="fab fa-instagram"></i
          ></a>
        </div>
        <p>&copy; 2023 Admire Tourism Website. All Rights Reserved.</p>
      </footer>
    </main>


    </div>
  );
}